import React from "react";
import { useParams } from "react-router-dom";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../Breadcrumb";
import { Helmet } from "react-helmet-async";
import bannerIMG from "../../../../src/assets/bannerImages/main-img.jpg";
import childImg1 from "../../../assets/img/child-img/indoor playground square fit 1.png";
import childImg2 from "../../../assets/img/child-img/indoor playground square fit 2.png";
import childImg3 from "../../../assets/img/child-img/indoor playground square fit 3.png";
import childImg4 from "../../../assets/img/child-img/indoor playground square fit 4.png";
import WhatsappButton from "../../../components/WhatsappButton";
import { Link } from "react-router-dom";
import plusicon from "../../../assets/img/product_img/plusicon.png";

const ProductsPlayground = () => {
  const { type } = useParams();
  console.log(type);
  let content;
    <WhatsappButton
      altText="Chat with us on WhatsApp"
      iconSize={70}
    />

  if (type === "SoftPlay") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "110%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor commercial playground"
            className="main-img"
          ></img>
        </div>
       
        <h1 className="p-heading">Soft Play</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              Perfect for High Jumps & Stunts – Designed for trampoline park
              enthusiasts performing aerial tricks, our equipment meets the
              highest standards. As a leader in indoor playground production in
              Jordan, we ensure top-quality designs that enhance performance and
              safety.
            </h2>
          </div>
        </div>

        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">Safe & Exciting Play Experience</h3>
            <ul typeof="text-box">
              <h2 className="ProductDetailsPage">
                GEM’s Soft Play Area combines the excitement of a trampoline
                park with thoughtfully designed soft play equipment. Our play
                structures include:
              </h2>
              <li className="p-text-2">Foam blocks</li>
              <li className="p-text-2">Soft mats</li>
              <li className="p-text-2">Tunnels & bridges</li>
              <li className="p-text-2">Slides & climbing frames</li>

              <h2 className="ProductDetailsPage">
                Each element is crafted to ensure a secure and stimulating
                experience for children to crawl, jump, climb, and slide in a
                fully protected environment.
              </h2>
              <h2 className="ProductDetailsPage">
                <b>Ideal for Family</b>-Friendly Venues
              </h2>
              <h2 className="ProductDetailsPage">
                GEM soft play playgrounds are the perfect addition to:
              </h2>
              <li className="p-text-2">Shopping centers</li>
              <li className="p-text-2">Family entertainment centers</li>
              <li className="p-text-2">Indoor amusement parks</li>
              <li className="p-text-2">
                Restaurants & cafes with kids’ play zones
              </li>
              <h2 className="ProductDetailsPage">
                As a leading family entertainment centers manufacturer in
                Jordan, we design innovative play areas that not only keep
                children entertained but also promote physical activity, social
                interaction, and cognitive development.
              </h2>
            </ul>
            <ul typeof="text-box">
              <h3 className="p-sub-heading-2">
                Why Choose GEM Soft Play Areas?
              </h3>
              <li className="p-text-2">High-quality, durable materials</li>
              <li className="p-text-2">Safety-first design for children</li>
              <li className="p-text-2">Customizable themes & layouts</li>
              <li className="p-text-2">Suitable for various indoor spaces</li>
              <h2 className="ProductDetailsPage">
                Transform your venue into a kid-friendly haven with GEM’s Soft
                Play Area. Contact us today to learn more about our premium
                indoor play solutions!
              </h2>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="kids playground" />
              <img src={childImg3} alt="indoor playground" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="playground equipment manufacturers" />
              <img src={childImg4} alt="playgrounds" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "Toddler") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "110%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="playground equipment manufacturers"
            className="main-img"
          ></img>
        </div>
       
        <h1 className="p-heading">Toddler</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              Our TODDLER area playground is a safe and secure space where
              toddlers can play and explore in a developmentally appropriate
              environment.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  GEM Toddler playgrounds are ideal for shopping centers, family
                  entertainment centers, and other indoor commercial playgrounds
                  designed for families with young children. As a leading indoor
                  playground manufacturer in Jordan, GEM ensures high-quality,
                  safe, and engaging play areas tailored to enhance children's
                  fun and development.{" "}
                </h2>
              </li>
            </ul>
          </div>
          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="indoor playground design" />
              <img src={childImg3} alt="playground equipment catalog" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor playground" />
              <img src={childImg4} alt="indoor playground design" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "RolePlay") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor playground"
            className="main-img"
          ></img>
        </div>
        
        <h1 className="p-heading">Role Play</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              As a leading indoor playground supplier in Jordan, we are excited
              to introduce our innovative role-play concept for kids. This
              unique attraction will help business owners stand out, increase
              foot traffic, and enhance visitor engagement. These interactive
              spaces provide children with endless opportunities for imaginative
              play, making their playground experience both educational and
              enjoyable.
            </h2>
          </div>
        </div>

        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Hospital</b> : Children can take on the roles of doctors,
                  nurses, and patients. The area will be equipped with toy
                  medical instruments, beds and examination tables. By engaging
                  in medical role play, children can learn about empathy and the
                  importance of caring for others.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Police Station</b>: They can play as police officers,
                  detectives, or even suspects. The space will include mini jail
                  cells, walkie-talkies, and other props to enhance the
                  experience. Role playing as police officers will promote
                  understanding of community safety.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Bank</b>: The space will include play money, ATMs, deposit
                  slips, and simple transaction counters. Engaging in role play
                  at the bank will help children understand the value of money,
                  saving, and making responsible financial decisions.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Restaurant</b>: Here they can explore the culinary arts.
                  Acting like chefs, or diners, using play kitchen appliances
                  and utensils to encourage fine motor skills development and
                  healthy eating habits.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Market</b>: This area will feature shelves stocked with
                  play food items, shopping carts, cash registers, and pretend
                  money. Through this role play, children will learn about money
                  management, and the concept of supply and demand.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Pet Shop</b>:Playing as pet owners, customers, or even
                  veterinarians, the kids will be introduced to the world of pet
                  care and responsibility.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>School</b>: It will be equipped with mini desks, a
                  whiteboard, books, and educational toys. Through interactive
                  role play, children will develop communication skills,
                  cooperation, and love for learning.
                </h2>
              </li>
            </ul>
            <h2 className="ProductDetailsPage">
              As a leading indoor playground supplier in Jordan, we offer a
              unique role-play playground concept that provides an exceptional
              play experience for children. Contact us today to explore how our
              innovative projects can enhance your operation, captivate young
              imaginations, and delight parents.
            </h2>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playground equipment company" />
              <img src={childImg3} alt="playgrounds" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="kids playground" />
              <img src={childImg4} alt="playground equipment catalog" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "CarTrack") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="playground equipment suppliers"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Car Track</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              As a leading soft play manufacturer in Jordan, we design soft play
              areas that provide young children with a safe and fun environment
              to explore. Our indoor playgrounds feature slides, foam blocks,
              mats, tunnels, and bridges—specifically crafted for climbing,
              crawling, sliding, and imaginative play, ensuring both safety and
              enjoyment.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  GEM soft play playgrounds are suitable for shopping centers,
                  family entertainment centers, and other indoor facilities that
                  cater to families with young children.{" "}
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="indoor commercial playground" />
              <img
                src={childImg3}
                alt="playground equipment manufacturers"
              />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="playground equipment manufacturers" />
              <img src={childImg4} alt="trampoline park with soft play" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "Zipline") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img src={bannerIMG} alt="playgrounds" className="main-img"></img>
        </div>
        <h1 className="p-heading">Zipline</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              Experience the thrill of flying with our indoor zipline, designed
              for safe and exciting play in indoor playgrounds. As a leading
              Indoor Playground Manufacturer in Jordan, we ensure our ziplines
              are built with high-quality materials and advanced safety
              features, providing smooth, controlled rides for all ages.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  At Global Entertainment Manufacturer, we ensure durability,
                  safety, and customization, making our ziplines a perfect
                  addition to any indoor adventure park. As a trusted Trampoline
                  Park Supplier in Jordan, we provide high-quality solutions to
                  upgrade your playground with a premium zipline experience.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="soft play" />
              <img src={childImg3} alt="trampoline company" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="trampoline parks" />
              <img src={childImg4} alt="trampoline parks" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "Slide") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="trampoline park with soft play"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Slide</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              Our soft play slider adds excitement to any indoor playground,
              allowing kids to slide safely from one play zone to another. As a
              trusted Indoor Playground Supplier in Jordan, we design our
              sliders with high-quality, cushioned materials to ensure a smooth
              and secure ride for endless fun.
            </h2>
          </div>
        </div>

        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  At Global Entertainment Manufacturer , we focus on safety,
                  durability, and innovative design, making our sliders a
                  perfect addition to any soft play area.Elevate your playground
                  with a thrilling sliding experience
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="soft play and trampoline" />
              <img src={childImg3} alt="soft play and trampoline" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="trampoline parks" />
              <img src={childImg4} alt="indoor family entertainment center" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "SandArea") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor playground design"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Sand Area</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              Our indoor sand play area creates a fun and interactive space
              where kids can dig, build,and explore using specially designed
              play equipment. Made with safe, non-toxic materials, it encourages
              creativity, sensory play, and social interaction.
            </h2>
          </div>
        </div>

        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  At Global Entertainment Manufacturer, we ensure durability,
                  hygiene, and engaging designs, making our sand play areas a
                  perfect addition to any indoor playground.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  Bring the joy of sand play indoors with us.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="indoor play equipment commercial" />
              <img src={childImg3} alt="playground equipment company" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="soft play" />
              <img src={childImg4} alt="playgrounds and parks" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "BallPool") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor playground with slide"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Ball Pool</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              Our ball pool offers a fun and safe play experience, filled with
              high-quality, soft plastic balls for endless excitement. Designed
              for indoor playgrounds, it provides a colorful, immersive
              environment where kids can jump, dive, and explore.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  At Global Entertainment Manufacturer, we prioritize safety,
                  durability, and engaging designs, making our ball pools a
                  perfect addition to any soft play area. As a leading Soft Play
                  Manufacturer in Jordan, we create vibrant and joyful play
                  spaces designed for endless fun and safety.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="trampoline park with soft play" />
              <img src={childImg3} alt="playground equipment suppliers" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="playground equipment catalog" />
              <img src={childImg4} alt="soft play installation" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "DoughnutSlide") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="soft play installation"
            className="main-img"
          ></img>
        </div>

        <h1 className="p-heading">Doughnut Ride</h1>

        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              WeGlobal Entertainment Manufacturer (GEM) brings excitement to
              life with our Doughnut Slide, a high-energy attraction designed
              for endless fun! This innovative slide transforms the thrill of
              sliding into a gravity-defying adventure, delivering a unique
              experience that keeps visitors coming back for more.{" "}
            </h2>
          </div>
        </div>

        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">Why Choose the Doughnut Slide?</h3>
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Exhilarating Ride</b> – Riders sit in specially designed
                  doughnut-shaped tubes and slide down a curved, high-speed
                  track for a smooth yet thrilling descent.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Safe & Comfortable</b> – Crafted from premium,
                  impact-resistant materials, ensuring a safe and enjoyable
                  experience for all ages.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Customizable Design</b> – Available in a variety of colors,
                  sizes, and themes to seamlessly integrate into your indoor
                  playground or trampoline park.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Fun for All Ages</b> – Designed to accommodate both kids and
                  adults, making it a must-have attraction for family
                  entertainment centers.
                </h2>
              </li>
            </ul>
            <h3 className="p-sub-heading-2">
              Perfect for Any Indoor Play Space
            </h3>
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  The Doughnut Slide is a dynamic addition to trampoline parks,
                  adventure parks, and entertainment centers. It boosts visitor
                  engagement, enhances the play area, and provides an
                  unforgettable sliding sensation that appeals to thrill-seekers
                  of all ages.
                </h2>
              </li>
            </ul>

            <h3 className="p-sub-heading-2">Bring the Thrill to Your Park!</h3>
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  Looking to elevate your indoor playground? Contact Global
                  Entertainment Manufacturer (GEM) today and let’s create
                  unforgettable fun together!
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="highest quality trampoline" />
              <img src={childImg3} alt="indoor playground with slide" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor commercial playground" />
              <img src={childImg4} alt="playground equipment manufacturers" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <Helmet>
        <meta
          name="soft play"
          content="Explore GEM's indoor play equipment commercial, 
designed for fun and safety. Perfect for any business
 looking to enhance kids' playtime with durable, exciting 
equipment."
        />

        <meta
          name="playgrounds and parks"
          content="GEM offers top-quality soft play installation services, 
creating safe and fun play environments for children. 
Enhance your space with our expert soft play solutions"
        />

        <meta
          name="indoor playground with slide"
          content="GEM offers top-quality soft play installation services,
 creating safe and fun play environments for children.
 Enhance your space with our expert soft play solutions"
        />

        <meta
          name="trampoline park with soft play"
          content="GEM creates innovative soft play installations with 
high-quality playground equipment. Trusted playground
 equipment manufacturers offering safe, 
fun solutions for kids."
        />

        <meta
          name="playground equipment suppliers"
          content="GEM is a leading soft play installation company offering
 high-quality playground equipment. Trusted playground 
equipment suppliers for safe and fun play environments."
        />

        <meta
          name="playground equipment catalog"
          content="Explore GEM's comprehensive playground equipment 
catalog, featuring a wide range of durable and fun play 
structures for all ages. Find the perfect playground 
solutions today!"
        />

        <meta
          name="soft play installation"
          content="GEM offers expert soft play installation services, creating
 fun and safe environments for children with high-quality, 
customizable play structures and designs."
        />

        <meta
          name="highest quality trampoline"
          content="GEM offers the highest quality trampoline designed for 
durability and safety, providing a superior bounce for 
endless fun. Discover the best trampoline today"
        />
        <meta
          name="indoor playground with slide"
          content="Discover the GEM trampoline, the highest quality for 
endless fun. Explore our indoor playground with a slide, 
offering a safe and exciting experience for all ages!"
        />
      </Helmet>

      <Header />
       <div>
        {/* Whats App Icon */}
        <WhatsappButton
            altText="Chat with us on WhatsApp"
            iconSize={70}
          />
        <Link
          to="/getquotations"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="icon-container">
            <img
              src={plusicon}
              alt="playground equipment suppliers"
              className="Producticon"
              style={{ cursor: "pointer" }}
            />
            <button className="quotation-button">Get Quotation</button>
          </div>
        </Link>
      </div>
      {content}
      <Footer />
    </div>
  );
};
export default ProductsPlayground;
